export default "__VITE_ASSET__cbgdECcV__"